import script from "./DiamondImages.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiamondImages.vue?vue&type=script&setup=true&lang=ts"

import "./DiamondImages.vue?vue&type=style&index=0&id=8a0c7f3e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a0c7f3e"]])

export default __exports__